export default "__VITE_ASSET__BmmWfBrJ__"